/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyFailureData {
    getFixupPrototypeFunction() { return PolicyFailureData.fixupPrototype; }

    static newInstance(model: Partial<PolicyFailureData>): PolicyFailureData {
        let obj = Object.assign(new PolicyFailureData(), model);
        PolicyFailureData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyFailureData>): PolicyFailureData {
        if (!model) return null;
        return PolicyFailureData.newInstance(<PolicyFailureData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyFailureData) {
        if (!obj) return;

        models.PolicyFailureData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyFailureData): boolean {
        Object.setPrototypeOf(obj, PolicyFailureData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * policy job name
     */
    policy_name: string;

    /**
     * policy job id
     */
    policy_job_id: string;

    /**
     * policy execution status
     */
    policy_execution_status: string;

    /**
     * status reason
     */
    status_reason: string;

    /**
     * assessment by
     */
    assessment_by: string;

    /**
     * region
     */
    region: string;

    /**
     * resource group
     */
    resource_group: string;

}
